import { AnalysisContextState } from "context/AnalysisContext/state";

export const getCustomModelId = (state: AnalysisContextState) => {
  return state.analysisModels?.find((model) => model.modelId === state.selectedModelId)?.isVirtual
    ? state.selectedModelId
    : null;
};
